import React from 'react'
import Collapse from 'blocks.simple/collapse/collapse'
import translate from 'core/translate'
import { cn } from 'ethcss'
import { grid } from '../../../theme'
import styles from '../settings.jcss'
import { TelegramSettings } from './_telegram/TelegramSettings'
import { RootStateOrAny, useSelector } from 'react-redux'

export const MessengersNotifications = () => {
    const appState = useSelector((state: RootStateOrAny) => state.app)
    const collapseRef: { onClick?: () => void } = {}

    const onClose = () => {
        if (collapseRef.onClick) {
            collapseRef.onClick()
        }
    }

    return appState && appState.externalServices && appState.externalServices.includes('telegramBot') ? (
        <Collapse
            refObj={collapseRef}
            title={() => translate('messengersNotifications')}
            className={cn(styles.background, grid.mb_md)}
        >
            <div className={grid.mb_md}>
                <TelegramSettings onClose={onClose} />
            </div>
        </Collapse>
    ) : null
}
